module.exports = __webpack_public_path__ + "img/03车门控制器软件DCU著作权.28398d87.png";